import {Document, columns} from "./columns"
import {DataTable} from "./data-table"
import {useCallback, useEffect, useState} from "react";
import axios from "axios";
import {useAuth} from "react-oidc-context";
import {PaginatedResponse} from "@/types/util";

export default function DocumentPage() {
    const [data, setData] = useState<PaginatedResponse<Document>>()
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        updateTableData()
    }, []);

    const auth = useAuth()


    const updateTableData = useCallback((options?: any) => {
        setLoading(true)
        const params = new URLSearchParams();
        params.append('include', 'order');
        if (options?.page) {
            params.append('page', String(options.page))
        }
        if (options?.perPage) {
            params.append('per_page', String(options.perPage))
        }

        for (const k in options?.filters) {
            const filters: string[] = []
            for (const v in options.filters[k]) {
                if (options.filters[k][v]) {
                    filters.push(v)
                }
            }
            params.append(`filter[${k}]`, `${filters.join(',')}`)
        }

        axios.get(`/api/documents?${params.toString()}`).then(res => {
            setData(res.data)
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            setLoading(false)
        })
    }, [])

    return (
        <div className="container mx-auto px-4">
            <DataTable
                columns={columns(auth)}
                data={data?.data ?? []}
                updateData={updateTableData}
                loading={loading}
                pagination={data ? {
                    currentPage: data.current_page,
                    perPage: data.per_page,
                    total: data.total,
                } : undefined}
            />
        </div>
    )
}
